import React from 'react';
import { useTranslation } from 'react-i18next';
import { Lot } from '../common/model/dto/lot';
import { RecordColumn } from '../common/model/ui/record-list.type';
import StringUtils from '../common/utils/services/string-utils';
import { LotFields } from '../firebase/document-field.enums';
import OvDateParser from '../components/UI/atoms/OvDateParser';
import OvPillLink from '../components/UI/atoms/OvPillLink';

export function useLotListColumns(): RecordColumn<Lot>[] {
  const { t } = useTranslation();

  return [
    {
      id: 'name',
      header: t('lots.fields.name'),
      sortKey: LotFields.name,
      cardRole: 'heading',
      renderCell: (lot) => StringUtils.displayValue(lot.name),
    },
    {
      id: 'document-id',
      header: t('lots.fields.documentId'),
      sortKey: LotFields.document_id,
      renderCell: (lot) => StringUtils.displayValue(lot.document_id),
    },
    {
      id: 'created-at',
      header: t('lots.fields.createdAt'),
      sortKey: LotFields.created_at,
      renderCell: (lot) =>
        lot.created_at && (
          <OvDateParser date={lot.created_at} format="MMM DD, YYYY - hh:mm A" />
        ),
    },
    {
      id: 'type',
      header: t('lots.fields.kind'),
      sortKey: LotFields.type,
      renderCell: (lot) => StringUtils.displayValue(lot.type || ''),
    },
    {
      id: 'action',
      header: t('common.action'),
      isHeaderHidden: true,
      cardRole: 'footer',
      renderCell: (lot, detailsPath = '') => (
        <OvPillLink
          to={detailsPath}
          aria-label={t('lots.detailsFor', {
            id: lot.document_id ?? lot.id,
          })}
        >
          {t('common.actions.seeDetails')}
        </OvPillLink>
      ),
    },
  ];
}
